import { render, staticRenderFns } from "./BoardCell.vue?vue&type=template&id=7753a49c&scoped=true&"
import script from "./BoardCell.vue?vue&type=script&lang=js&"
export * from "./BoardCell.vue?vue&type=script&lang=js&"
import style0 from "./BoardCell.vue?vue&type=style&index=0&id=7753a49c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7753a49c",
  null
  
)

export default component.exports